import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  TextField,
  Autocomplete,
  FormControl,
  InputLabel,
  CircularProgress,
  Box,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import {
  getProvinceDetail,
  getDestinationDetail,
} from "../../../../redux/centerData/CenterDataSlice";

function Filter() {
  const [provinceFilter, setProvinceFilter] = useState("");
  const [islandFilter, setIslandFilter] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedIsland, setSelectedIsland] = useState("");
  const [loading, setLoading] = useState(true);
  const [provinceLabelVisible, setProvinceLabelVisible] = useState(true);
  const [islandLabelVisible, setIslandLabelVisible] = useState(true);

  const dispatch = useDispatch();
  const provinces = useSelector(
    (state) => state.CenterDataSlice.Province.results
  );
  const islands = useSelector(
    (state) => state.CenterDataSlice.Destination.results
  );
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  useEffect(() => {
    dispatch(getProvinceDetail());
    dispatch(getDestinationDetail());
  }, [dispatch]);

  useEffect(() => {
    if (provinces && islands) {
      setLoading(false);
    }
  }, [provinces, islands]);

  const handleIslandChange = (event, newValue) => {
    setSelectedIsland(newValue);
    // Add your logic for handling the selected island
  };

  const [filteredIslands, setFilteredIslands] = useState([]);

  const handleProvinceChange = (event, newValue) => {
    setSelectedProvince(newValue);

    // Find the province object in the provinces array based on its name
    const selectedProvinceObject = provinces.find(
      (province) => province.ProvinceEng === newValue
    );
    if (selectedProvinceObject) {
      // Extract the ProvinceID from the selected province object
      const provinceID = selectedProvinceObject.ProvinceID;

      // Filter the islands based on the selected province ID
      const filteredIslands = islands.filter(
        (island) => island.id_province === provinceID
      );

      // Now you have the filtered islands based on the selected province
      // Update the options prop of the Autocomplete component with the filtered islands
      setFilteredIslands(filteredIslands);
    } else {
      setFilteredIslands([]); // Reset filtered islands if selected province is not found
    }

    // Clear the selected island when the province changes
    setSelectedIsland("");
  };

  return (
    <div className="Filter-dropdown">
      <Box
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <span className="mr-10">Filter</span>

        <FormControl>
          <InputLabel
            sx={{
              color: "rgba(255, 255, 255, 0.5)",
              marginTop: 1,
              marginBottom: 1,
              display: provinceLabelVisible ? "block" : "none",
            }}
          >
            Province
          </InputLabel>
          <Autocomplete
            id="province-select"
            sx={{
              width: "200px", // Set the width
              height: "50px", // Set height for the root element
              backgroundColor: "#00305c", // Set the background color (dark blue)
              color: "white", // Set text color to white (should display white text)
              borderRadius: 8, // Set the border radius
              marginTop: 1,
              marginBottom: 1,
              fontSize: "14px", // Set the font size

              "& .MuiOutlinedInput-root": {
                // Target the styled input root
                borderRadius: 8,
                width: "200px", // Set the width
                height: "50px",
              },
              "& .MuiAutocomplete-inputRoot": {
                color: "white", // Set text color to white
              },
              "& .MuiInputLabel-root": {
                // Target the label element
                color: "rgba(255, 255, 255, 0.5)", // Set label text color to white
              },
              "& .MuiAutocomplete-clearIndicator": {
                // Target the clear button icon
                color: "white", // Change the color of the clear button icon
              },
              "& .MuiAutocomplete-popupIndicator": {
                // Target the dropdown icon
                color: "white", // Change the color of the dropdown icon
              },
            }}
            value={selectedProvince}
            onChange={handleProvinceChange}
            onFocus={() =>
              setProvinceLabelVisible(false) && setIslandLabelVisible(true)
            }
            onBlur={() => {
              if (!selectedProvince) {
                setProvinceLabelVisible(true);
                setIslandLabelVisible(true);
              }
            }}
            options={
              provinces?.map(
                selectedLanguage === "en"
                  ? (option) => option.ProvinceEng
                  : (option) => option.ProvinceThai
              ) || []
            }
            renderInput={(params) => <TextField {...params} />}
            disabled={loading}
          />
        </FormControl>

        <FormControl>
          <InputLabel
            sx={{
              color: "rgba(255, 255, 255, 0.5)",
              marginTop: 1,
              marginBottom: 1,
              marginLeft: 3,
              display: islandLabelVisible ? "block" : "none",
            }}
          >
            Island
          </InputLabel>
          <Autocomplete
            id="island-select"
            sx={{
              width: "200px", // Set the width
              height: "50px", // Set height for the root element
              backgroundColor: "#00305c", // Set the background color (dark blue)
              color: "white", // Set text color to white (should display white text)
              borderRadius: 8, // Set the border radius
              marginRight: 1,
              marginLeft: 3,
              marginTop: 1,
              marginBottom: 1,
              fontSize: "14px", // Set the font size

              "& .MuiOutlinedInput-root": {
                // Target the styled input root
                borderRadius: 8,
                width: "200px", // Set the width
                height: "50px",
              },
              "& .MuiAutocomplete-inputRoot": {
                color: "white", // Set text color to white
              },
              "& .MuiInputLabel-root": {
                // Target the label element
                color: "rgba(255, 255, 255, 0.5)", // Set label text color to white
              },
              "& .MuiAutocomplete-clearIndicator": {
                // Target the clear button icon
                color: "white", // Change the color of the clear button icon
              },
              "& .MuiAutocomplete-popupIndicator": {
                // Target the dropdown icon
                color: "white", // Change the color of the dropdown icon
              },
            }}
            value={selectedIsland}
            onChange={handleIslandChange}
            onFocus={() => setIslandLabelVisible(false)}
            onBlur={() => {
              if (!selectedIsland) {
                setIslandLabelVisible(true);
              }
            }}
            options={
              filteredIslands.map((option) => option.name_destination_en) || []
            }
            renderInput={(params) => <TextField {...params} />}
            disabled={loading || !selectedProvince} // Disable Island selection if no Province is selected
          />
        </FormControl>
        {loading && null}
      </Box>
    </div>
  );
}

export default Filter;
